<template>
    <div>
        <div id="gallery-results">
            <loading v-if="loading"></loading>
            <media v-if="!loading" v-for="(result, index) in results" :key="index" :media="result" :card="true" :stats="true"
                @click.native="showMediaViewer(index, result)">
                <a v-if="!loggedOut" :href="result.user.links.profile" target="_blank" v-miniprofile="result.user.id" class="btn btn-xs btn-dark-ghost dropdown-toggle">
                    <i class="fa fa-user"/>
                </a>
            </media>
            <div v-if="!loading && (!results || !results.length)">
                <hr>
                {{ noResults }}
                <hr>
            </div>
        </div>
        <pagination v-if="!loading && totalPages > 1" @page-changed="setPage" :page="filters.page" :total="totalPages"></pagination>
    </div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import Loading from 'Site/component/Loading.vue';
import Media from 'Media/component/Media.vue';
import miniprofileDirective from 'Profile/directive/miniprofile';
import Pagination from 'Site/component/Pagination.vue';
import SearchRouting from 'Site/js/mixin/search.routing';
import { mapState } from 'vuex';

export default {
    name: 'GalleryResults',
    components: {
        Loading,
        Media,
        Pagination
    },
    mixins: [SearchRouting],
    computed: {
        ...mapState('galleryFilters', [
            'filters',
            'resetValues',
        ]),
        ...mapState({
            adultAllowed: state => state.config.data.adultAllowed,
            gt: state => state.gt.common,
            notEmailVerified: state => state.config.data.verifyId !== null,
        }),
        noResults() {
            return this.errorAlert ? this.gt.error_alert : this.gt.no_results;
        }
    },
    directives: {
        miniprofile: miniprofileDirective
    },
    data() {
        return {
            errorAlert: false,
            loading: false,
            loggedOut: this.$store.state.config.loggedOut || false,
            resetPage: false,
            results: this.$store.state.config.data.results,
            store: 'galleryFilters',
        };
    },
    methods: {
        setPage(page) {
            this.$store.commit('galleryFilters/SET_FILTER', { key: 'page', value: page });
        },
        fetchData(data) {
            this.loading = true;
            this.errorAlert = false;

            // get collection
            ajax.get('gallery', data).then((response) => {
                this.loading = false;
                this.results = response.items;
                this.totalPages = Math.ceil(response.count / this.showperpage);
            }).catch(() => {
                this.loading = false;
                this.results = '';
                this.errorAlert = true;
            });
        },
        showMediaViewer(start, result) {
            if (this.loggedOut) {
                this.$store.dispatch('showJoin');
                return;
            }
            if (this.notEmailVerified) {
                this.$emit('email-verify');
                return;
            }
            if (result.adult && !this.adultAllowed) {
                this.$store.dispatch('showUpgrade', { reason: 'view-explicit-media' });
                return;
            }
            if (!this.loggedOut) {
                const filters = Object.assign({}, this.activeFilters);
                const media = Object.assign([], this.results);
                let mediaViewerPage = this.filters.page;
                this.currentPageCheck(filters);
                delete filters.page;

                this.$store.dispatch('showMediaViewer', {
                    callback: function callback(response) {
                        if (response === 'loadmore') {
                            const data = Object.assign({}, this.activeFilters);
                            data['max-results'] = this.showperpage;
                            data.sort = this.filters.sort;
                            mediaViewerPage += 1;
                            data.page = mediaViewerPage;
                            // set page (max-results x (pageNum-1))
                            if (data.page) {
                                const pageMultiplier = data.page - 1; // offset by -1 so page 2 is x1 multiplier ( 0 x 25 = 0, 1 x 25 = 25)
                                data['start-index'] = pageMultiplier * data['max-results'];
                                delete data.page;
                            }
                            ajax.get('gallery', data).then(({ items }) => {
                                this.$store.dispatch('addMediaToViewer', items);
                            });
                        }
                    }.bind(this),
                    media,
                    start
                });
            }
        }
    }
};
</script>
